import { z } from "zod";

/**
 * User report schema for dating app
 * Represents reports submitted by users about inappropriate behavior
 */
export const UserReportSchema = z.object({
  /** ID of the user making the report */
  uid: z.string().optional().describe("ID of the user submitting the report"),

  /** ID of the user being reported */
  reported_user_uid: z.string().optional().describe("ID of the user being reported"),

  /** Category/type of the report */
  report_type: z.string().optional().describe("Type of report (harassment, fake profile, etc.)"),

  /** Detailed description of the issue */
  report_content: z.string().optional().describe("Detailed description of the reported behavior"),

  /** When the report was submitted */
  date: z.date().optional().describe("When the report was submitted"),

  /** Location context for the report */
  location: z.string().optional().describe("Location context where the issue occurred"),
});

export type UserReport = z.infer<typeof UserReportSchema>;
